/** @format */

import usePrice from '@/@ducks/cardRoom/hooks/usePrice';
import { TRoom } from '@/@ducks/room/declarations';
import PinIcon from '@/assets/joivy_poi_miniature_pink.svg';
import { TTranslation, useAppTranslation } from '@/i18n/declarations';
import React, { useMemo } from 'react';
import { PinIconContainer, PinSingleIconContainer } from './Pin.style';

interface PinProps {
  dataMarker: number;
}

interface RoomPriceMakersPinProps extends PinProps {
  room: TRoom;
  selected?: boolean | null;
}

export const SinglePin: React.FC<PinProps> = ({ dataMarker }) => {
  return (
    <PinSingleIconContainer data-marker={dataMarker}>
      <img src={PinIcon} alt="Map pin" />
    </PinSingleIconContainer>
  );
};

export const RoomPriceMakersPin: React.FC<RoomPriceMakersPinProps> = ({ selected = false, dataMarker, room }) => {
  const { formattedPrice } = usePrice(room!);
  const { t } = useAppTranslation();

  const memoizedFormattedPrice = useMemo(() => formattedPrice, [formattedPrice]);

  return (
    <PinIconContainer
      $selected={selected}
      data-marker={dataMarker}
      title={t('plp.map_pin_show_room' as TTranslation, { code: room.code })}
    >
      <span>{memoizedFormattedPrice}</span>
    </PinIconContainer>
  );
};
